import { render } from "./lhbdDetail.vue?vue&type=template&id=37bde7a6&scoped=true&ts=true"
import script from "./lhbdDetail.vue?vue&type=script&lang=ts"
export * from "./lhbdDetail.vue?vue&type=script&lang=ts"

import "./lhbdDetail.vue?vue&type=style&index=0&id=37bde7a6&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bde7a6"]])

export default __exports__